































































































module.exports =
  name: 'account_edit'
  components:
    balance:                    require('components/inside/elements/balance.vue').default
    destroy_confirmation_modal: require('components/inside/pages/accounts/destroy_confirmation.vue').default
    offline_bar:                require('components/inside/offline_bar.vue').default
  data: ->
    form: _.clone(@$store.state.ui.accounts.edited)
    display_credit_limit: false
    rules:
      name: [
        { required: true, message: @$t('name_is_required'), trigger: 'blur' }
      ]
      balance: [
        { required: true, message: @$t('balance_is_required') },
        { type: 'number', message: @$t('balance_is_number') }
      ]
    formValid: false
    ready_to_delete: false

  computed:
    edited:     -> @$store.state.ui.accounts.edited
    categories: -> @$store.getters.account_categories
    currencies: -> @$store.state.user.currencies
    can_change_currency: -> @edited.isNew() or @account_transactions_length == 0
    account_transactions_length: ->  @$store.state.user.transactions.filter((tr) => tr.isRelatedToAccount(@edited.id)).length
  watch:
    display_credit_limit: ->
      @form?.credit_limit = 0 if @display_credit_limit == false
    edited: ->
      @ready_to_delete = false
      @form = _.clone(@$store.state.ui.accounts.edited)
      @display_credit_limit = @form?.credit_limit != 0
      if @form?.id && !HM.is_mobile
        @$nextTick => $(@$el).find("[name='balance']").focus()
  methods:
    close: -> @$store.commit 'ACCOUNTS/EDIT', null
    submitForm: ->
      @$store.dispatch 'saveAccount', @form
      HM.track("account-create", { in_budget: @form.is_in_budget }) if @form.isNew()
      HM.track("account-update", { in_budget: @form.is_in_budget }) if !@form.isNew()
      @close()
      @$message.success @$t('Done')
    destroy: (form) ->
      @$store.dispatch 'destroyAccount', @form
      HM.track("account-destroy", { in_budget: @form.is_in_budget })
      @$message.success @$t('Done')
      @close()

    validateForm: ->
      return unless @$refs.form
      @$refs.form.validate (valid) => @formValid = valid
    queryCategories: (queryString, cb) ->
      res = @$store.getters.account_categories.filter (cat) ->
        cat_name = cat.name.toLowerCase()
        return cat_name.includes(queryString.toLowerCase())
      result = _.map res, (category) ->
        {
          value: category.name
          label: category.name
        }
      if cb
        cb(result)
      else
        return result

  mounted: ->
    @$watch 'form', @validateForm, { immediate: true, deep: true }
